export const mapCompanyApiToVm = company =>
  company && {
    id: company.id,
    name: company.name,
  };

export const mapCompaniesApiToVm = companies => (Array.isArray(companies) ? companies.map(mapCompanyApiToVm) : []);
